export default "/images/vendor/flag-icon-css/flags/1x1/kw.svg?0924dc178a2cf893e78dbafb705cd391";